import React, { useEffect, useState } from 'react'
import useSeccionesStore from "../store/seccionesStore";
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import ModalEliminar from './ModalEliminar';
import { useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

const TableDataLayer = ({datosTabla,datos,cabecera = []}) => {
    const auth = useAuth();

    const location = useLocation();
    const [sucurales] = useState(auth.user?.sucursales || [])
    const [esCargando, setesCargando] = useState(true)
    const [esAgregar, setesAgregar] = useState(false)
    const [esActualizar, setesActualizar] = useState(false)
    const [esEliminar, setesEliminar] = useState(false)
    const {secciones, iniciar} = useSeccionesStore();
    const [idSucursal, setIdSucursal] = useState(0);
    useEffect(() => {
        iniciar();
    }, [])

    useEffect(() => {
        const index = secciones.findIndex(sec => sec.RUTA_SEC === location.pathname);
        console.log(index);
        if (index !== -1) {
            setesAgregar(secciones[index].CREAR_PER);
            setesActualizar(secciones[index].ACTUALIZAR_PER);
            setesEliminar(secciones[index].BORRAR_PER);
        }
        else{
            const subs = secciones.filter(x => x.SUBSECCION != null);
            
            for (let index = 0; index < subs.length; index++) {
                const element = subs[index];
                const elemento = JSON.parse(element.SUBSECCION);

                const subIndex = elemento.findIndex(sec => sec.RUTA_SEC === location.pathname);

                if (subIndex !== -1) {
                    setesAgregar(secciones[subIndex].CREAR_PER);
                    setesActualizar(secciones[subIndex].ACTUALIZAR_PER);
                    setesEliminar(secciones[subIndex].BORRAR_PER);
                }
            }
        }
        setesCargando(false)
    }, [secciones])


    const [elId, setElId] = useState(0);

    const formatearFecha = (fecha) => {
        return fecha.toLocaleString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'UTC'
        });
    };

    const obtenerDatos = () => {
        return(datos.filter(x => {
            return(datosTabla.keySucursal != null && datosTabla.keySucursal !='' && idSucursal != 0) ? x[datosTabla.keySucursal] == idSucursal : x
        }));
    }

    useEffect(() => {
        if (esCargando) return;

        const columns = cabecera.map(c => {
            if (c.render) {
                return {
                    title: c.title,
                    data: c.key,
                    render: c.render
                }
            }
            if (c.isDate) {
                return {
                    title: c.title,
                    data: c.key,
                    render: (data) => data ? formatearFecha(new Date(data)).trim() : ''
                }
            }
            return { title: c.title, data: c.key };
        });

        if ((datosTabla.esEditar && esActualizar) || (datosTabla.esEliminar && esEliminar) || datosTabla.esVerDetalle) {
            columns.push({
                title: 'ACCIONES',
                data: null,
                orderable: false,
                searchable: false,
                render: (data, type, row) => {
                    const viewButton = datosTabla.esVerDetalle ?
                        `<a href="${datosTabla.rutaVerDetalle}/${row[cabecera[0].key]}" class="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center">
                            <i class="ri-eye-line" style="font-size: 16px;"></i>
                        </a>` : '';

                    const editButton = (datosTabla.esEditar && esActualizar) ?
                        `<a href="${datosTabla.ruta}/${row[cabecera[0].key]}" class="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center">
                            <i class="ri-edit-line" style="font-size: 16px;"></i>
                        </a>` : '';

                    const deleteButton = (datosTabla.esEliminar && esEliminar) ?
                        `<button type="button" class="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center delete-btn" data-id="${row[cabecera[0].key]}" data-bs-toggle="modal" data-bs-target="#exampleModalView">
                            <i class="ri-delete-bin-2-line" style="font-size: 16px;"></i>
                        </button>` : '';

                    return `<div class='d-flex justify-content-center'>${viewButton}${editButton}${deleteButton}</div>`;
                }
            });
        }

        const filteredData = obtenerDatos();

        const table = $('#dataTable').DataTable({
            ...datosTabla.configTable,
            data: filteredData,
            columns: columns,
            destroy: true,
        });

        $('#dataTable tbody').on('click', '.delete-btn', function () {
            const id = $(this).data('id');
            setElId(id);
        });

        return () => {
            $('#dataTable tbody').off('click', '.delete-btn');
            table.destroy();
        };
    }, [datos, idSucursal, esCargando, secciones, cabecera, datosTabla]);

    return (
        esCargando ? <></> :

        <>
            <div className="card basic-data-table">
                <div className="card-header col-12 d-flex justify-content-between align-items-center">
                    <div className='d-flex'>
                        <h5 className="card-title">{datosTabla.titulo}</h5>
                        {
                            (datosTabla.keySucursal != null && datosTabla.keySucursal !='' ) &&
                            <select name='select' style={{marginLeft: '15px'}} onChange={(e) => setIdSucursal(e.target.value)}>
                                <option value={0}>Todas las sucursales</option>
                                {sucurales.map((item) => (
                                    <option key={item.ID_SUC} value={item.ID_SUC}>{item.NOMBRE_SUCURSAL_SUC}</option>
                                ))}
                            </select>
                        }
                    </div>
                    { (datosTabla.esAgregar && esAgregar) && 
                        <Link to={`${datosTabla.ruta}/0`}><button type="button" className="btn btn-success">Agregar</button></Link> 
                    }
                    
                </div>
                <div className="card-body" style={{ overflowX: 'auto', width: '100%' }}>
                    <table
                        className="table bordered-table mb-0"
                        id="dataTable"
                        data-page-length={10}
                        style={{ width: '100%', borderCollapse: 'collapse'}}
                    >
                        <thead>
                            <tr>
                                {cabecera.map((item, index) => <th key={index} scope="col">{item.title}</th>)}
                                {
                                    ((datosTabla.esEditar && esActualizar) || (datosTabla.esEliminar && esEliminar) || datosTabla.esVerDetalle) &&
                                    <th scope="col">ACCIONES</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* <!-- Modal --> */}
            <ModalEliminar onId={()=>{datosTabla.eliminar(elId)}} />
        </>

    )
}

export default TableDataLayer